import { CHI_SIAMO } from "@/config/site";
import { goToForm } from "@/lib/prefill";

export const ChiSiamo = () => (
  <section id="chi-siamo" className="bg-ivory py-20 lg:py-28" data-testid="chi-siamo-section">
    <div className="container-ph grid gap-10 lg:grid-cols-2 lg:gap-16 items-center">
      <div className="reveal lg:order-2">
        <span className="gold-line mb-5" />
        <p className="eyebrow">{CHI_SIAMO.eyebrow}</p>
        <h2 className="h-section mt-3" data-testid="chi-siamo-title">{CHI_SIAMO.title}</h2>
        <p className="mt-6 text-base sm:text-lg text-ink/75 leading-relaxed" data-testid="chi-siamo-p1">{CHI_SIAMO.p1}</p>
        <p className="mt-4 text-base sm:text-lg text-ink/75 leading-relaxed" data-testid="chi-siamo-p2">{CHI_SIAMO.p2}</p>
        <ul className="mt-8 space-y-3">
          {CHI_SIAMO.points.map((pt, i) => (
            <li key={pt} className="flex items-center gap-4 text-sm sm:text-base text-forest" data-testid={`chi-siamo-point-${i + 1}`}>
              <span className="h-px w-8 bg-bronze shrink-0" />{pt}
            </li>
          ))}
        </ul>
        <button className="btn-primary mt-9" onClick={() => goToForm({})} data-testid="chi-siamo-button">{CHI_SIAMO.button}</button>
      </div>
      <div className="reveal reveal-delay-1 lg:order-1 relative">
        <img src={CHI_SIAMO.image} alt={CHI_SIAMO.alt} loading="lazy" className="w-full aspect-[4/3] object-cover" />
        <span className="absolute -bottom-3 -right-3 h-full w-full border border-bronze/60 -z-10 hidden sm:block" />
      </div>
    </div>
  </section>
);
